import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import RegexValidationHelper from '../../../helpers/regexValidation.js';

const ChangeEmailContent = ({ dispatch, currentEmail, emailDomains, emailExtensions }) => {
  const [showChangeEmailErrorDetail, setShowChangeEmailErrorDetail] = useState(false);

  const [showChangeConfirmEmailErrorDetail, setShowChangeConfirmEmailErrorDetail] = useState(false);

  const [showChangeEmailPasswordErrorDetail, setShowChangeEmailPasswordErrorDetail] = useState(false);

  const isEmailDomainSpecificValidate = (email, emailDomains) => {
    if (email && (emailRegex.test(email.trim()) || email.trim().length < '256')) {
      let emailArray = email.split('@')[1].split('.');
      let emailExtension = `${emailArray[emailArray.length - 2]}.${emailArray[emailArray.length - 1]}`
        .toLowerCase()
        .trim();

      let regionResults = emailDomains.split(',').filter((ext) => {
        return emailExtension.toLowerCase().trim() === ext.toLowerCase().trim();
      });

      return regionResults.length > 0;
    }
  };

  const formik = useFormik({
    initialValues: {
      newEmail: '',
      confirmEmail: '',
      newPassword: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.newEmail) {
        errors.newEmail = APP.LANGUAGE.ChangeEmail.NewEmailError.V1;
      } else {
        if (values.newEmail > 1) {
          errors.newEmail = APP.LANGUAGE.ChangeEmail.NewEmailError.V2;
        } else if (values.newEmail.trim().toLowerCase() === currentEmail.trim().toLowerCase()) {
          errors.newEmail = APP.LANGUAGE.ChangeEmail.NewEmailError.V3;
        } else {
          if (!emailRegex.test(values.newEmail.trim()) || values.newEmail.trim().length > '256') {
            errors.newEmail = APP.LANGUAGE.ChangeEmail.NewEmailError.V2;
          } else {
            if (emailDomains) {
              if (isEmailDomainSpecificValidate(currentEmail, emailDomains)) {
                if (!isEmailDomainSpecificValidate(values.newEmail.trim(), emailDomains)) {
                  errors.newEmail = APP.LANGUAGE.ChangeEmail.NewEmailError.V4;
                }
              }
            }
          }
        }
      }

      if (!values.confirmEmail) {
        errors.confirmEmail = APP.LANGUAGE.ChangeEmail.ConfirmEmailError.V1;
      } else if (
        values.confirmEmail &&
        values.confirmEmail.trim().toLowerCase() !== values.newEmail.trim().toLowerCase()
      ) {
        errors.confirmEmail = APP.LANGUAGE.ChangeEmail.ConfirmEmailError.V2;
      }

      if (!values.newPassword) {
        errors.newPassword = APP.LANGUAGE.ChangeEmail.PasswordError.V1;
      } else if (values.newPassword.length < 6) {
        errors.newPassword = APP.LANGUAGE.ChangeEmail.PasswordError.V2;
      }

      return errors;
    },
  });

  useEffect(() => {
    if (!formik.errors.newEmail) {
      setShowChangeEmailErrorDetail(false);
    }
  }, [formik.errors.newEmail]);

  useEffect(() => {
    if (!formik.errors.confirmEmail) {
      setShowChangeConfirmEmailErrorDetail(false);
    }
  }, [formik.errors.confirmEmail]);

  useEffect(() => {
    if (!formik.errors.newPassword) {
      setShowChangeEmailPasswordErrorDetail(false);
    }
  }, [formik.errors.newPassword]);

  let fields = [
    {
      label: APP.LANGUAGE.ChangeEmail.NewEmail,
      name: 'newEmail',
      type: 'text',
      id: 'changeEmailEmail',
      className: 'user-change-email_new-email mrbl',
      value: formik.values.newEmail,
      handleChange: formik.handleChange,
      handleBlur: formik.handleBlur,
      showErrorDetail: showChangeEmailErrorDetail,
      setErrorDetail: setShowChangeEmailErrorDetail,
      errors: formik.errors.newEmail,
      focusme: 'true',
      autocomplete: 'new-password',
      touched: formik.touched.newEmail,
    },
    {
      label: APP.LANGUAGE.ChangeEmail.ConfirmEmail,
      name: 'confirmEmail',
      type: 'text',
      id: 'changeConfirmEmail',
      className: 'user-change-email_confirm-email mrbl',
      value: formik.values.confirmEmail,
      handleChange: formik.handleChange,
      handleBlur: formik.handleBlur,
      showErrorDetail: showChangeConfirmEmailErrorDetail,
      setErrorDetail: setShowChangeConfirmEmailErrorDetail,
      errors: formik.errors.confirmEmail,
      focusme: 'false',
      autocomplete: 'new-password',
      touched: formik.touched.confirmEmail,
    },
    {
      label: APP.LANGUAGE.ChangeEmail.Password,
      name: 'newPassword',
      type: 'password',
      id: 'changeEmailPassword',
      className: 'user-change-email_password mrbs',
      value: formik.values.newPassword,
      handleChange: formik.handleChange,
      handleBlur: formik.handleBlur,
      showErrorDetail: showChangeEmailPasswordErrorDetail,
      setErrorDetail: setShowChangeEmailPasswordErrorDetail,
      errors: formik.errors.newPassword,
      focusme: 'false',
      autocomplete: 'new-password',
      touched: formik.touched.newPassword,
    },
  ];

  window.addEventListener('paste', (event) => {
    if (event.target.id === 'changeConfirmEmail') {
      event.preventDefault();
    }
  });

  return (
    <>
      <CenterPanel formik={formik} fields={fields} currentEmail={currentEmail} />
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <div className="right ui rail pdrxs">
          <div className="ui sticky ">
            <RightPanel dispatch={dispatch} formik={formik} currentEmail={currentEmail} />
          </div>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="right pdrxs">
          <div className="ui sticky ">
            <RightPanel dispatch={dispatch} formik={formik} currentEmail={currentEmail} />
          </div>
        </div>
      </Container>
    </>
  );
};

const emailRegex = RegexValidationHelper.EMAIL_REGEX;

ChangeEmailContent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  currentEmail: PropTypes.string.isRequired,
  emailDomains: PropTypes.string,
  emailExtensions: PropTypes.string,
};

ChangeEmailContent.defaultProps = {
  emailDomains: '',
  emailExtensions: '',
};

export default ChangeEmailContent;
